import { BEExternalService } from '../../../../../../api/com/MetaPattern/MDA/MD/EntityModel/BEExternalService';
import { EnumBEType } from '../../../../../../api/com/MetaPattern/MDA/MD/EntityModel/EnumBEType';

export class BEExternalServiceExtend {
  public static Init(dto: BEExternalService) {
    dto.bEType = EnumBEType.BEExternalService;
  }
}
